import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import GapDataGrid from 'reusable/mui/data-grid/GapDataGrid'
import { useFeatureToggleStore } from './FeatureToggleStore'

export default observer(function BetaOptInList() {
   const featureToggleStore = useFeatureToggleStore()

   return <>
      <Box sx={{ mb: 2 }}>
         <Typography variant="body2" color="text.secondary">
            {featureToggleStore.betaOptedInOrgs.length} advisor org{featureToggleStore.betaOptedInOrgs.length === 1 ? '' : 's'} opted in
            {' · '}
            {featureToggleStore.betaToggleCount} toggle{featureToggleStore.betaToggleCount === 1 ? '' : 's'} currently in beta
         </Typography>
      </Box>
      <GapDataGrid
         columns={[
            { field: 'name', headerName: 'Org name', flex: 1 },
            { field: 'id', headerName: 'Org ID', flex: 1 },
         ]}
         rows={featureToggleStore.betaOptedInOrgs}
         noRowsText="No advisor orgs have opted in to beta features yet."
      />
   </>
})
